export default "__VITE_ASSET__Jei2n5JS__"